const statementHistorySchema = [
  {
    id: "date",
    label: "Date",
    type: "date",
    config: {
      formatType: "date",
    },
  },
  {
    id: "narration",
    label: "Transaction",
    type: "text",
  },
  {
    id: "debit",
    label: "Debit",
    type: "currency",
  },
  {
    id: "credit",
    label: "Credit",
    type: "currency",
  },
  {
    id: "loan_outstanding",
    label: "Loan Outstanding",
    type: "currency",
  },
  {
    id: "excess_credit",
    label: "Cumulative Excess Credit",
    type: "currency",
  },
];

export default statementHistorySchema;
